<template>
  <div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <div class="px-6 py-4 grey--text">
          <div>{{ $t("to") }}: {{ agent.name_agent }}</div>
          <div class="caption">ID: {{ agent.id_agent }}</div>
          <div class="pt-2">{{ $t("balanceLabel") }}: {{ agent.balance }}</div>
        </div>
        <v-divider></v-divider>
        <div class="ma-4">
          <v-row>
            <v-col cols="4">
              <div class="pa-4 text-right">{{ $t("launchType") }}:</div>
            </v-col>
            <v-col cols="8">
              <v-radio-group v-model="radios" row>
                <v-radio value="1" class="mb-2">
                  <template v-slot:label>
                    <div>
                      <strong class="success--text">{{
                        $t("receiveFromAgent")
                      }}</strong>
                    </div>
                  </template>
                </v-radio>
                <v-radio value="2" class="mb-2">
                  <template v-slot:label>
                    <div>
                      <strong class="red--text">{{ $t("payToAgent") }}</strong>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <div class="pa-4 text-right">{{ $t("valueLabel") }}:</div>
            </v-col>
            <v-col cols="8">
              <v-text-field
                :label="$t('valueLabel')"
                v-model="valueEntry"
                :rules="valueEntryRules"
                required
                clearable
                outlined
                type="number"
                :prefix="this.$t('labelCurrency')"
                dense
                class="mr-4 mt-2"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loading"
            v-on:click.prevent="insertEntryAgent"
            type="submit"
            :disabled="!valid"
          >
            {{ $t("btnSave") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { validate } from "@/util/validate.js";
export default {
  name: "regional-manager-financial-collection-insert-entry-agent",
  props: ["agent"],
  data: () => ({
    valid: false,
    radios: "1",
    valueEntry: "",
    rules: {
      required: validate.required,
    },
    checkField: {
      required: "Este campo é obrigatório",
    },
    loading: false,
  }),
  computed: {
    valueEntryRules() {
      const rules = [];
      // Required
      if (this.checkField.required) {
        const rule = (v) => !!v || this.$t("valueEntryRules");
        rules.push(rule);
      }
      return rules;
    },
  },
  methods: {
    insertEntryAgent: async function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;

      const body = {
        id_agent: this.agent.id_agent,
        value: this.valueEntry,
        type: this.radios,
      };
      try {
        const result = await this.$request.post(
          "regionalManager/financial/insertEntryDeal",
          body
        );
        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });
        this.$refs.form.reset();
        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
